import { TwitterIcon } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Button } from "../ui/button";
import { useGetProfileApiCallQuery } from "@/services/api/auth/auth.api";
import {
  API_BASE_URL,
  API_BASE_URL_NEW,
  AUTH_API_ENDPOINT,
} from "@/constants/constant";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  useUpdateMediaCredtionalApiCallMutation,
  useDisconnectSocialMediaApiCallMutation,
} from "@/services/api/campaigns/campaigns.api";
import { toast } from "sonner";
export const clientId = "TE13aGg1YmF3MzFWSlBUcV9QVkU6MTpjaQ"; // Replace with yours
// const redirectUri = ${API_BASE_URL}/api/v1/admin/result; // Replace with yours

// export const redirectUri = http://93.127.166.12:3000/api/v1/admin/result; // Replace with yours
// export const redirectUri = https://node-airdrop.bingold.to/api/v1/admin/result;
export const redirectUri =
  "https://airdrop.bingold.to/dashboard/profile-settings";

// Helper: Generate random string
const generateRandomString = (length: number) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

// Helper: Generate PKCE code_challenge
export const getCodeChallenge = async (codeVerifier: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  const base64Url = btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
  return base64Url;
};

const TwitterLogin = ({
  isConnected,
  socialCredentialsTelegram,
}: {
  isConnected?: boolean;
  socialCredentialsTelegram: any;
}) => {
  const [statusMessage, setStatusMessage] = useState("Ready to log in");
  const { data: userProfile } = useGetProfileApiCallQuery();
  const [updateMedia] = useUpdateMediaCredtionalApiCallMutation();
  const [disconnectSocial, { isLoading: isDisconnecting }] =
    useDisconnectSocialMediaApiCallMutation();
  const navigate = useNavigate();

  const [codes, setCodes] = useState("");
  const [states, setStates] = useState("");

  const [data, setData] = useState();

  const location = useLocation();
  const baseUrl = location.pathname;

  // Get everything after the "?"
  const queryString = location.search; // includes the "?" at the start
  // Example: "?code=123ABC&tab=privacy"

  // Optionally, remove the "?" if you want only the query part
  const queryWithoutQuestionMark = queryString.substring(1);

  const getPaymentMethod = async () => {
    console.log(
      "tokenDatassssssssssssssssssssssssssssssssssss65464534534354354s",
    );

    try {
      const codeVerifier = localStorage.getItem("codeVerifier");
      if (codes && codeVerifier) {
        console.log(
          "tokenDatasssssssssssssssssssssssssssssssssssss",
          codes,
          redirectUri,
          codeVerifier,
        );
        const responsess = await axios(
          "https://node-airdrop.bingold.to/api/v1/admin/result",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            params: {
              code: codes,

              state: codeVerifier || "",
            },
          },
        );

        console.log("tokenDataaaaaaaaaaaaaaaaaaaaaaaa", responsess);

        const tokenData = await responsess.data.result;
        console.log("tokenData", tokenData);

        try {
          const response = await updateMedia(tokenData).unwrap();

          toast.success(response.responseMessage);
          window.location.reload();
        } catch (error) {
          const fetchError = error as any;
          const errorData = fetchError?.data;
          toast.error(
            errorData?.responseMessage || "Error updating Twitter credentials",
          );
          console.error("Error updating Twitter:", error);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPaymentMethod();
  }, [codes]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");

    if (code) {
      setStatusMessage("Received authorization code. Attempting to log in...");
      const codeVerifier = localStorage.getItem("codeVerifier");

      console.log("Authorization Code:", code);
      console.log("Code Verifier:", codeVerifier);
      console.log("State:", state);

      setCodes(code);
      // Here you would send code + codeVerifier to your backend
      setTimeout(() => {
        setStatusMessage(
          "Token exchange request sent to backend. Check console.",
        );
      }, 1000);
    } else if (urlParams.get("error")) {
      setStatusMessage("Twitter login was canceled or an error occurred.");
      console.error("Twitter Error:", urlParams.get("error"));
    }
  }, []);

  const handleLogin = async (e: React.MouseEvent) => {
    e.preventDefault();

    // Step 1: Open window immediately on user gesture
    const authWindow = window.open("", "_blank");

    // Step 2: Continue async logic
    const state = generateRandomString(16);
    const codeVerifier = generateRandomString(128);
    localStorage.setItem("codeVerifier", codeVerifier);
    const codeChallenge = await getCodeChallenge(codeVerifier);

    const authUrl = `https://twitter.com/i/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUri,
    )}&scope=tweet.read%20users.read%20like.read%20tweet.write%20follows.read%20follows.write%20offline.access&state=${state}&code_challenge=${codeChallenge}&code_challenge_method=S256`;

    // Step 3: Navigate the opened window
    if (authWindow) {
      authWindow.location.href = authUrl;
    } else {
      // Fallback in case popup was blocked
      window.location.href = authUrl;
    }
  };

  const handleDisconnect = async () => {
    try {
      const response = await disconnectSocial({ platform: "Twitter" }).unwrap();
      toast.success(
        response.responseMessage || "Twitter account disconnected.",
      );
      window.location.reload();
    } catch (error) {
      const fetchError = error as any;
      toast.error(
        fetchError?.data?.responseMessage ||
          "Error disconnecting Twitter account.",
      );
    }
  };

  return (
    <div className="flex w-full">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 p-4 bg-gray-800/50 rounded-lg w-full">
        <div className="flex items-center space-x-3 min-w-0">
          <div className="w-10 h-10 bg-gray-700 rounded-lg flex items-center justify-center shrink-0">
            <TwitterIcon className="w-5 h-5" />
          </div>
          <div className="min-w-0">
            <span className="text-white font-medium capitalize truncate block">
              {socialCredentialsTelegram?.result?.username || ""}
            </span>
          </div>
        </div>

        <div className="flex items-center shrink-0 w-full sm:w-auto justify-end">
          {isConnected ? (
            <div className="flex items-center gap-2 flex-wrap justify-end">
              <span className="text-green-500 border border-green-600 rounded-full px-3 py-1 text-sm whitespace-nowrap">
                Connected
              </span>
              <Button
                onClick={handleDisconnect}
                disabled={isDisconnecting}
                variant="outline"
                size="sm"
                className="cursor-pointer border-red-500/30 text-red-400 hover:bg-red-500 hover:text-white whitespace-nowrap"
              >
                {isDisconnecting ? "Disconnecting..." : "Disconnect"}
              </Button>
            </div>
          ) : (
            <Button
              onClick={handleLogin}
              className="cursor-pointer whitespace-nowrap"
            >
              Login with Twitter
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TwitterLogin;
